import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import { buildItemTitle, buildOptionsString } from '@functions/orderItem'

import useArtwork from '@hooks/useArtwork'

import type { ArtworkModel } from '@models/types'

interface ArtworkProps {
  artwork: ArtworkModel,
  callbacks: {
    selectArtwork: VoidFunction,
  },
}

const Artwork = (props: ArtworkProps) => {
  const {
    artwork,
    callbacks: {
      selectArtwork,
    },
  } = props

  const artworkPayload = useArtwork(artwork)
  const {
    orderItem,
    selectedArtworkPage,
  } = artworkPayload

  const previewImageUrl = digObject(selectedArtworkPage, 'previews.thumb')
  const updatedDateTime = digObject(artwork, 'dates.updated.date_time', 'Never Updated')

  return (
    <ListItem
      boxProps={{ borderBottom: '1px dashed', paddingY: 'large' }}
      onClick={selectArtwork}
      showAngleIcon
    >
      <Box width="auto">
        <Image
          backgroundSize="contain"
          borderRadius={5}
          boxProps={{ backgroundColor: 'whiteGrey', border: '1px solid', borderColor: 'lineColor' }}
          height={80}
          width={80}
          url={previewImageUrl}
        />
      </Box>

      <Box justifyContent="center" flexDirection="column" marginLeft="medium">
        <Text fontSize="small">
          {/*
           // @ts-expect-error TS2339 */}
          {orderItem.id
            ? buildItemTitle({ excludeOptionsString: true, orderableItem: orderItem })
            : 'Deleted Item'}
        </Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          {/*
           // @ts-expect-error TS2339 */}
          {buildOptionsString(orderItem.options || [])}
        </Text>
        <Text color="lightGrey" fontSize="xsmall" marginTop="small">
          {updatedDateTime}
        </Text>
      </Box>
    </ListItem>
  )
}

export default Artwork
